import { ArrowTopRightOnSquareIcon } from "@heroicons/react/20/solid";
import { createFileRoute } from "@tanstack/react-router";
import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "src/components/base/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "src/components/base/table";
import SINGLE_TAG_CONTEXT from "src/context/customer/tag";

/**
 * The properties for {@link CustomerAssociatedDevices}
 */
export type CustomerAssociatedDevicesProps = {};

/**
 * The customer view for associated devices on a tag
 */
export default function CustomerAssociatedDevices(props: CustomerAssociatedDevicesProps) {
    const [t] = useTranslation("customer-tag");
    const [tg] = useTranslation();

    const tagContext = React.useContext(SINGLE_TAG_CONTEXT);

    return (
        <>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableHeader>{t("label.device-name")}</TableHeader>
                        <TableHeader className={"w-0"}>
                            <span className={"sr-only"}>{tg("accessibility.actions")}</span>
                        </TableHeader>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {tagContext.tag.devices.map((device) => (
                        <TableRow key={device.uuid}>
                            <TableCell>{device.dnsname}</TableCell>
                            <TableCell>
                                <Button
                                    plain={true}
                                    href={"/c/devices/$deviceId/general"}
                                    params={{ deviceId: device.uuid }}
                                >
                                    <ArrowTopRightOnSquareIcon />
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </>
    );
}
export const Route = createFileRoute("/_customer/c/tags/$tagId/_tags/associated")({
    component: CustomerAssociatedDevices,
});
